export default __webpack_public_path__ + "static/media/addPlaylist.6ac95803.png";